
import React, { useEffect, useRef, useState } from "react";
import FilterIcon from "../assets/filterIcon.png";
import Person from "../assets/person.png";
import Search from "../assets/search.png";
import TimeTable from "../assets/time_table.svg";
import Header from "./Header.js";
import { Eye } from "lucide-react";
import DatePicker from "react-datepicker";
import {

    filter_booking_data,
    customer_view_deatils, server_post_data,

} from "../ServiceConnection/serviceconnection.js";
import {
    ViewStaffPagesText,
    options_search_car,
    status_search,

} from "../CommonJquery/WebsiteText.js";
import Loader from "./Loader.js";

import { CalendarClock, IdCard } from "lucide-react";
import { Modal } from 'react-bootstrap';
import { Button } from "@mui/material";
import {
    computeTodayDate,
    computeplussevendays,
    formatDateStringdot,
    handleEmailChange,
    handleError,
    handleIaphabetnumberChange,
    handleNumbersChange, handleAphabetsChange
    , mondayDayYearFormat,
    formatToYYYYMMDD

} from "../CommonJquery/CommonJquery.js";
import { useParams } from "react-router-dom";
const ViewCustomer = () => {
    let flag = "1";
    let { id } = useParams();
    const call_id = id
    //console.log("call_id", call_id);
    const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
    const [editStaffData, seteditStaffData] = useState([]);


    let formattedSevenDaysAgo = computeplussevendays();
    let formattedToday = computeTodayDate();
    const selectedStatus = localStorage.getItem("selectedStatusFilter");


    const [flagData, setflagData] = useState("1");
    // Set initial state using useState hook
    const [startDate, setStartDate] = useState(formattedSevenDaysAgo);
    const [endDate, setEndDate] = useState(formattedToday);
    const [searchfilter, setSearchFilter] = useState("");
    const [filteredData, setfilteredData] = useState([]);
    const [selectedValue, setSelectedValue] = useState("Name");
    const [statusValue, setstatusValue] = useState("");

    const handleSelect = (event) => {
        setSelectedValue(event.target.value);
    };
    useEffect(() => {
        master_data_get('', '', flag, call_id)
    }, [])
    const search_data = () => {
        flag = "2";
        master_data_get(startDate, endDate, flag, call_id);
    };
    const master_data_get = async (start_date, end_date, flag, call_id) => {
        setshowLoaderAdmin(true);
        const fd = new FormData();
        setflagData(flag);
        fd.append("start_date", formatToYYYYMMDD(start_date));
        fd.append("end_date", formatToYYYYMMDD(end_date));
        fd.append("flag", flag);
        fd.append("customer_id", call_id);
        fd.append("search_option", selectedValue);
        fd.append("search_data", document.getElementById("search_data").value);
        await server_post_data(customer_view_deatils, fd)
            .then((Response) => {
                //console.log("Show_data", Response.data.message);
                if (Response.data.error) {
                    handleError(Response.data.message);
                } else {
                    seteditStaffData(Response.data.message.user_data);
                    setfilteredData(Response.data.message.user_data);
                }

                setshowLoaderAdmin(false);
            })
            .catch((error) => {
                handleError("network");
                setshowLoaderAdmin(false);
            });
    };






    const handleSearch = (event) => {
        const searchValue = event.target.value;
        setSearchFilter(searchValue);

        const filteredDatashow = editStaffData.filter((row) => {
            return Object.values(row.car_data).some((value) => {
                if (value !== null && value !== undefined) {
                    // Add null check here
                    return (
                        typeof value === "string"
                            ? value.toLowerCase()
                            : value.toString().toLowerCase()
                    ).includes(searchValue.toLowerCase());
                }
                return false;
            });
        });

        setfilteredData(filteredDatashow);
    };




    const [showModal, setShowModal] = useState(false);
    const [values, setValues] = useState();


    const handleShowModal = (data) => {
        setValues(data)
        setShowModal(!showModal);
    };
    const handleDateChange = (date) => {
        setStartDate(date);
    };
    return (
        <>
            <Header />
            {showLoaderAdmin && <Loader />}

            <div className="reservationHistory">
                <div className="viewStaff_head">
                    <div className="row m-0">
                        <div className="col-lg-2 col-sm-4 bottomAlgin">
                            <label className="labelView">
                                {ViewStaffPagesText.Start_Date}
                            </label>
                            <div className="person__calenderFrame_image image_icon_position1 ">
                                <DatePicker
                                    selected={startDate}
                                    onChange={handleDateChange}
                                    className="form-control input_field_custom4"
                                    maxDate={computeTodayDate()}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"
                                />
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-4 bottomAlgin">
                            <label className="labelView">{ViewStaffPagesText.End_Date}</label>
                            <div className="person__calenderFrame_image image_icon_position1 ">
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    className="form-control input_field_custom4"
                                    maxDate={computeTodayDate()}
                                    minDate={startDate}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-4 bottomAlgin">
                            <div className="inputDiv2">
                                <label className="labelPointer" htmlFor="selectFilter">
                                    <img src={FilterIcon} alt="Rapid Car Leasing" />
                                </label>
                                <select id="selectFilter" onChange={handleSelect}>
                                    {options_search_car.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-5 col-sm-8 bottomAlgin">
                            <div className="inputDiv2">
                                <img src={Search} alt="Rapid Car Leasing" />
                                <input
                                    type="text"
                                    id="search_data"
                                    onInput={(e) => {
                                        if (selectedValue === options_search_car[0].value) {
                                            handleAphabetsChange(e);
                                        } else if (selectedValue === options_search_car[1].value) {
                                            handleEmailChange(e);
                                        }
                                        //  else if (selectedValue === options_search_car[2].value) {
                                        //     handleNumbersChange(e);
                                        // }
                                    }}
                                    placeholder={ViewStaffPagesText.Search_Employee_reservation}
                                />
                                <button
                                    type="button"
                                    className="btnSearch"
                                    onClick={() => search_data()}
                                >
                                    {ViewStaffPagesText.Search_text}
                                </button>
                            </div>
                        </div>

                        <div
                            className="mt-2"
                            style={{
                                display: "flex",
                                justifyContent: "end",
                                flexDirection: "row",
                                marginLeft: "auto",
                                marginRight: "0",
                            }}
                        >
                            {/* <div className="col-lg-3 col-sm-4 bottomAlgin">
                                <div className="inputDiv2">
                                    <label className="labelPointer" htmlFor="selectFilter">
                                        <img src={FilterIcon} alt="Rapid Car Leasing" />
                                    </label>
                                    <select
                                        id="selectFilter"
                                        onChange={handleStatusSelect}
                                        value={statusValue}
                                    >
                                        {status_search.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div> */}
                            <div className="inputDiv2">
                                <label className="labelPointer" htmlFor="selectFilter">
                                    <img src={Search} alt="Rapid Car Leasing" />
                                </label>
                                <input
                                    type="text"
                                    placeholder={ViewStaffPagesText.Staff_Filter_reservation}
                                    onInput={handleIaphabetnumberChange}
                                    value={searchfilter}
                                    onChange={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="reservationHistoryTable">
                    <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                    >
                        <table className="table margin_class_table">
                            <thead className="stickyHeaderClss">
                                <tr>
                                    <th scope="col">Sr.No.</th>
                                    <th scope="col">Time</th>
                                    <th scope="col">Name</th>

                                    <th scope="col">
                                        <img src={Person} alt="Rapid Car Leasing" />
                                    </th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="custum_border">
                                {filteredData.map((option, index) => (
                                    <tr className="historyTableRow" key={index}>
                                        <td>
                                            <div
                                                style={{
                                                    marginLeft: "1rem",
                                                    fontSize: "14px",
                                                    marginTop: "1.2rem",
                                                }}
                                            >
                                                {index + 1}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="topMargin historyTime">
                                                <p>{formatDateStringdot(option.entry_date)}</p>
                                            </div>
                                        </td>
                                        <td>

                                            <div className="topMargin historyTime">
                                                {/* <p>{formatDateStringdot(option.entry_date)}</p> */}
                                                {console.log(option)}
                                                <div className="historyTimeImgText align-items-start">
                                                    <img src={TimeTable} alt="Rapid Car Leasing" />
                                                    <p>
                                                        {option.car_data &&
                                                            option.car_data['car_name']}
                                                        (
                                                        {option.car_data &&
                                                            option.car_data['car_tagline']}
                                                        )
                                                        <p>
                                                            {option.car_data &&
                                                                option.car_data['car_no']}
                                                        </p>
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="historyTableRowText historyName">
                                                <h6 className="infoDetalisStats">Insurance:- {option.insurance_company} </h6>
                                                <p>Insurance No.: {option.insurance}</p>
                                                <p>Insurance Expiry date:-{option.insurance_expiration_date}</p>
                                            </div>
                                        </td>

                                        <td>
                                            <div
                                                className="historyTableRowText historyPerson"
                                                style={{ flexWrap: "wrap" }}
                                            >
                                                <div>

                                                    <IdCard className="tble_icon" strokeWidth={1.5} />
                                                    <p>From Date: {option.from_date}</p>
                                                </div>
                                                <div>

                                                    <CalendarClock
                                                        className="tble_icon"
                                                        strokeWidth={1.5}
                                                    />
                                                    <p>
                                                        Expiry date:{" "}
                                                        {option.end_date}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="historyTableRowText historyActions">
                                                <div className="historyActionsBtns View_custmer_eye mb-2">
                                                    <Eye size={18} onClick={() => handleShowModal(option)} style={{ cursor: "pointer" }} />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {filteredData.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className="text_align_center">
                                            No Results Found
                                        </td>{" "}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal show={showModal} centered scrollable onHide={handleShowModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5 className="your_total_blnce">Your Total Balance</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="summary-container">
                        <table className="summary-table">
                            <tbody>
                                <tr>
                                    {console.log(values)}
                                    <td>Rent</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['per_date_charge']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Used Tolls Bal till</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            // value={values.tolls}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Maintainance</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_maintance']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Damage & Others</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_damagefees']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td>Late Fees</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_latefees']}
                                            readOnly

                                        />
                                    </td>
                                </tr> */}
                                <tr>
                                    <td>Balance for Deposit</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_deposit']}
                                            readOnly

                                        />
                                    </td>
                                </tr>
                                <tr className="total-row">
                                    <td>Total</td>
                                    <td className="amount">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={values && values['total_balance']}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleShowModal}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => alert("Saved!")}>
                        Save Changes
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
};

export default ViewCustomer;
